import { fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";

const why = { fits: "Fits", risk: "Risk too big", cash: "Lot too expensive" };

export const HkFit = () => {
  const { data } = useFetch("/fees/hk-fit");
  return (
    <Panel title="HK stocks that fit your risk per trade" className="mb-3" testid="hk-fit">
      {!data ? <Spinner /> : (
        <>
          <p className="mb-2 text-xs text-slate-600" data-testid="hk-fit-budget">
            Risk per trade RM{fmt(data.risk_budget_myr, 2)} · max one position RM{fmt(data.exposure_cap_myr, 2)} · {data.rows.filter((r) => r.fits).length} of {data.rows.length} HK stocks fit.
          </p>
          <div className="custom-scrollbar max-h-96 overflow-auto"><table className="tbl w-full" data-testid="hk-fit-table">
            <thead><tr><th>Stock</th><th>Lot</th><th>1 lot RM</th><th>Stop distance</th><th>Risk 1 lot</th><th>Fees in+out</th><th>Fees share of risk</th><th>Max lots</th><th>Result</th></tr></thead>
            <tbody>{data.rows.map((r) => (
              <tr key={r.symbol} data-testid={`hk-fit-row-${r.symbol}`} className={r.fits ? "" : "opacity-60"}>
                <td><span className="mono font-semibold">{r.symbol}</span> <span className="text-[10px] text-slate-500">{r.name}</span></td>
                <td className="mono">{r.lot}</td><td className="mono">{fmt(r.one_lot_myr, 2)}</td><td className="mono">HK${r.stop_dist}</td>
                <td className="mono font-bold">RM{fmt(r.risk_one_lot_myr, 2)}</td><td className="mono">RM{fmt(r.fees_one_lot_myr, 2)}</td>
                <td className={`mono ${r.fee_share_pct > 50 ? "text-red-600" : "text-amber-600"}`}>{r.fee_share_pct}%</td>
                <td className="mono">{r.max_lots}</td>
                <td className={`mono text-[10px] font-semibold ${r.fits ? "text-emerald-600" : "text-slate-500"}`} data-testid={`hk-fit-result-${r.symbol}`}>{why[r.limit]}</td>
              </tr>))}
            </tbody></table></div>
          <p className="mt-2 text-[10px] text-slate-500">{data.note} When fees are more than half of the risk, even a winning trade earns little after costs.</p>
        </>
      )}
    </Panel>
  );
};
